import * as types from "../actions/types/index";

const INITIAL_STATE = {
    words: [],
};
export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.SET_PROFANITY_WORDS:
            return {
                ...state,
                words: action.payload
            };
        default:
            return {
                ...state
            }
    }
}